<template>
  <div class="case-container">
    <div class="top">
      <!-- 筛选 -->
      <div class="search-item">
        <div class="search-time" @click.stop="bindShowSearch">
          <div class="text">营期</div>
          <div class="search-text">
            <div>{{ currentClamp }}</div>
          </div>
          <span class="iconfont icon-sousuo"></span>
        </div>
      </div>
      <div class="search-item">
        <div class="item">
          <div class="search-time" @click="bindshowCalendar(0)">
            <div class="text" v-show="!startTime">开始时间</div>
            <div class="search-text">
              <div>{{ startTime || '' }}</div>
            </div>
            <span class="iconfont icon-xiala" v-if="!startTime"></span>
            <span
              class="iconfont icon-cha"
              v-else
              @click.stop="clearStartTime"
            ></span>
          </div>
        </div>
        <div class="item">
          <div class="search-time" @click="bindshowCalendar(1)">
            <div class="text" v-show="!endTime">结束时间</div>
            <div class="search-text">
              <div>{{ endTime || '' }}</div>
            </div>
            <span class="iconfont icon-xiala" v-if="!endTime"></span>
            <span
              class="iconfont icon-cha"
              v-else
              @click.stop="clearEndTime"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="refresh-content">
      <van-pull-refresh
        v-model="refresh"
        success-text="刷新成功"
        @refresh="onRefresh()"
        style="min-height: 100%"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="true"
          @load="loadData(false)"
        >
          <div class="content">
            <div class="item-info" v-if="currentClamp !== '全部营期'">
              <div class="class-name">{{ currentClamp }}</div>
              <div class="number">{{ total }}</div>
            </div>
            <div class="class-item" v-for="(item, index) in data" :key="index">
              <div class="item-time">{{ item.addDay }}</div>
              <div class="image-list">
                <div
                  class="image-item"
                  v-show="item1.type == 1"
                  v-for="(item1, index1) in item.data"
                  :key="index1"
                >
                  <PictureItem
                    :list="item.data"
                    :data="item1"
                    :index="index"
                    :index1="index1"
                    @click="imageClick"
                  />
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 搜索营期组件 -->
    <SearchCamp
      v-if="showSearch"
      :data="classOption"
      @hidesearch="bindHideSearch"
      @confirm="bindSelectCamp"
    />
    <!-- 日历组件 -->
    <van-calendar
      v-model="showCalendar"
      @confirm="onConfirm"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </div>
</template>
<script>
import scroll from '@/components/scroll'
import PictureItem from '@/views/business-center/components/knowledge/picture-item/index'
import SearchCamp from '@/views/business-center/components/knowledge/search-camp/index'
import Base64 from '@/common/base64.js'
export default {
  name: 'picture-class',
  components: {
    PictureItem,
    scroll,
    SearchCamp
  },
  data() {
    return {
      minDate: new Date('2021/06/30 00:00:00'),
      maxDate: new Date(),
      showCalendar: false, //显示日历组件
      curCalendar: 0, //当前日历组件显示的是哪个
      pickerStartTime: '2021-01-01',
      pickerEndTime: '',
      id: 64,
      title: '21天',
      total: 0, //总数量
      page: 1,
      fid: '', //营期id
      loading: false,
      finished: false,
      refresh: false,
      data: [],
      dateObject: {}, //保存图片的日期数据
      dayObject: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ],
      currentClamp: '全部营期',
      showSearch: false, //是否显示搜索组件
      showCalendar: false,
      showPicker: false,
      minDate: new Date('2021/06/30 00:00:00'),
      maxDate: new Date(),
      startTime: '', //搜索开始时间
      endTime: '', //搜索结束时间
      loaded: false,
      classOption: [
        {
          text: '全部营期',
          alias: '全部营期',
          name: '全部营期',
          id: 0,
          value: 0
        }
      ],
      coachOption: []
    }
  },
  computed: {},
  beforeRouteEnter(to, form, next) {
    if (
      form.path == '/fatcamp/knowledge-base/second_class' ||
      form.path == '/'
    ) {
      to.meta.ifDoFresh = true
    } else {
      to.meta.ifDoFresh = false
    }
    next()
  },
  created() {
    this.getCurTime()
    this.getParams(this.$route.query)
    this.getPro()
  },
  activated() {
    this.getParams()
    if (!this.isLoaded) {
      this.loadData(true)
    } else {
      if (this.$route.meta.ifDoFresh) {
        this.$route.meta.ifDoFresh = false
        ;(this.startTime = ''), (this.endTime = ''), (this.pid = '')
        this.resetData()
        this.loadData(true)
      }
    }
    this.isLoaded = true
  },
  methods: {
    bindshowCalendar(index) {
      this.curCalendar = index
      this.showCalendar = true
    },
    onConfirm(date) {
      this.showCalendar = false
      let val = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      if (this.curCalendar === 0) {
        this.startTime = val
      } else if (this.curCalendar === 1) {
        this.endTime = val
      }
      this.resetData()
    },
    resetData() {
      this.finished = false
      this.page = 1
      this.loading = true
      this.data = []
      this.loadData(true)
    },
    //刷新数据
    onRefresh() {
      this.resetData()
    },
    imageClick(index, index1) {
      let data = encodeURIComponent(
        Base64.encode(JSON.stringify(this.data[index].data[index1]))
      )
      this.$router.push({
        path: '/fatcamp/preview-image',
        query: {
          index: index,
          index1: index1,
          data: data
        }
      })
    },
    //清空开始时间
    clearStartTime() {
      this.startTime = ''
      this.resetData()
    },
    //清空结束时间
    clearEndTime() {
      this.endTime = ''
      this.resetData()
    },
    //显示搜索营期组件
    bindShowSearch() {
      this.showSearch = true
    },
    //显示搜索营期组件
    bindHideSearch() {
      this.showSearch = false
    },
    //完成搜索营期后获取到营期信息
    bindSelectCamp(data) {
      this.currentClamp = data.name
      this.fid = data.id
      this.resetData()
    },
    bindStartTimeChange(value) {
      this.startTime = value
      this.resetData()
    },
    bindEndTimeChange(value) {
      this.endTime = value
      this.resetData()
    },
    getCurTime() {
      let curDay = this.filterTime(new Date())
      this.pickerEndTime = curDay
    },
    filterTime(time) {
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = time.getDate()
      day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day
    },
    getParams(options) {
      this.id = (options && options.id) || ''
      this.title = options && decodeURIComponent(options.title || '')
      document.title = this.title
    },
    //获取营期列表
    getPro() {
      this.$http
        .postApp('member/StorageLogin/getQue', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = res.data.map((item) => {
              item.text = item.title
              item.value = item.id
              return item
            })
            this.classOption = this.classOption.concat(data)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //加载数据
    loadData(isCover) {
      let params = {
        tid: this.id,
        page: this.page,
        s_date: this.startTime,
        e_date: this.endTime,
        fid: this.fid
      }
      this.$http
        .postApp('member/StorageLogin/getTypeList', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.total = (res.data && res.data.total) || 0
            this.loaded = true
            let newData = this.dealData(res.data.data || [])
            if (res.data.data && res.data.data.length) {
            } else {
              this.finished = true
            }
            this.page++
            if (isCover) {
              this.data = this.filterData(newData)
              this.refresh = false
            } else {
              this.data = this.data.concat(this.filterData(newData))
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          //this.finished = true
          console.log(e)
        })
        .finally(() => {
          this.refresh = false
          this.loading = false
        })
    },
    dealData(data) {
      data = data.filter((item) => {
        return item.type == 1
      })
      return data
    },
    //处理数据 将同一天的图片放在一个数组内
    filterData(data) {
      let obj = {}
      data.map((item) => {
        let time = new Date(item.addtime.replace(/-/g, '/'))
        let timeStr =
          time.getFullYear() +
          '年' +
          (time.getMonth() + 1) +
          '月' +
          time.getDate() +
          '日 ' +
          this.dayObject[time.getDay()]
        if (!this.dateObject[timeStr]) {
          obj[timeStr] = {
            addDay: timeStr,
            data: [item]
          }
          this.dateObject[timeStr] = timeStr
        } else {
          obj[timeStr].data.push(item)
        }
      })
      let res = []
      this.dateObject = {}
      for (let i in obj) {
        res.push(obj[i])
      }
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.case-container {
  background: #fff;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.case-container .top {
  position: sticky;
  width: 100%;
  top: 0vw;
  box-sizing: border-box;
  padding: 20px;
  background-color: #fff;
  z-index: 6;
  border-bottom: 1px solid #f1f1f1;
}
.case-container .top .search-item {
  width: 100%;
  height: 10.7vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  margin-bottom: 10px;
}
.top .search-item:last-child {
  margin-bottom: 0px;
}
.search-item .picker {
  width: 152px;
  overflow: hidden;
}
.search-item .picker-100 {
  width: 100%;
}
.case-container .top .search-item .search-time {
  width: 100%;
  height: 100%;
  padding: 2.7vw 3.2vw;
  box-sizing: border-box;
  overflow: hidden;
  background: #f7f7f7;
  border-radius: 1.7vw;
  display: flex;
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-item .item {
  width: 151px;
  height: 100%;
}
.case-container .top .search-item .search-time .text {
  font-size: 3.5vw;
  color: rgba(0, 0, 0, 0.5);
  margin: 0px 5px;
}
.top .search-item .search-input {
  position: relative;
  flex-shrink: 0;
  flex: 1;
  width: 100%;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 3.5vw;
  color: #000;
  font-weight: 600;
}
.search-input .clear {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translate(0%, -50%);
}
.case-container .top .search-item .search-time .search-text {
  flex-shrink: 0;
  flex: 1;
  width: 100%;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 3.5vw;
  color: #000;
  font-weight: 600;
}
.case-container .top .search-item .search-time .iconfont {
  color: #ccc;
  padding: 5px;
}
.case-container .top .search-item:nth-child(2n) {
  margin-right: 0%;
}
.case-container .content {
  padding: 9px 0px;
  box-sizing: border-box;
}
.case-container .content .item-info {
  padding: 0px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.1vw;
}
.case-container .content .item-info .class-name {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 5.6vw;
  font-size: 4vw;
  color: #000;
  font-weight: 600;
}
.case-container .content .item-info .number {
  font-size: 4vw;
  color: #808080;
}
.case-container .content .class-item .item-time {
  padding: 0vw 4.3vw;
  box-sizing: border-box;
  line-height: 4.5vw;
  font-size: 3.2vw;
  color: rgba(0, 0, 0, 0.5);
  text-align: left;
  margin-bottom: 2.9vw;
}
.case-container .content .class-item .image-list {
  padding-bottom: 1vw;
  border-bottom: 1px solid #f7f7f7;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.case-container .content .class-item .image-list .image-item {
  border-radius: 1.1vw;
  overflow: hidden;
}
.case-container .content .class-item .image-list .image-item:nth-child(3n) {
  margin-right: 0vw;
}

.refresh-content {
  width: 100%;
  flex: 1;
  flex-shrink: 0;
  overflow-y: scroll;
}
.loading {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%);
}
.not-data {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px;
  color: rgba(0, 0, 0, 0.5);
}
</style>
